export class FetchJsonError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FetchJsonError';
  }
}

export const isAbortError = (error: unknown): error is DOMException =>
  error instanceof DOMException && error.name === 'AbortError';

type FetchJsonOptions = RequestInit & {
  fallbackMessage?: string;
};

export async function fetchJson<T>(
  url: string,
  { fallbackMessage = 'Request failed', ...init }: FetchJsonOptions = {}
): Promise<T> {
  let response: Response;

  try {
    const { headers, ...rest } = init;
    response = await fetch(url, {
      ...rest,
      headers: { Accept: 'application/json', ...headers },
    });
  } catch (error) {
    if (isAbortError(error)) {
      throw error;
    }
    throw new FetchJsonError(fallbackMessage);
  }

  if (!response.ok) {
    throw new FetchJsonError(fallbackMessage);
  }

  let data: unknown;
  try {
    data = await response.json();
  } catch {
    throw new FetchJsonError(fallbackMessage);
  }

  return data as T;
}
